











/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import ApplyMixin from '@mixin/apply';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    mixins: [
        ApplyMixin,
    ],

    methods: {
        groupTitleClass(option) {
            const classes = ['apply-progress__group-title']

            if (option.done)
                classes.push('apply-progress__group-title--done');

            if (option.current)
                classes.push('apply-progress__group-title--current');

            return classes.join(' ');
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ApplyProgress extends Vue {};

